import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../store/selectors";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../common/LanguageSwitcher";
import { useQuery } from "../../hooks/useQuery";
import { trackAdobeClick } from "../../utils/adobeLogging";
import appSettings from "../../utils/appSettings";


const SplashPage = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const orgName = query.get("org");
  const orgAssessmentSync = query.get("sync");
  const isAuthenticated = useSelector((state) => selectIsAuthenticated(state));
  const acceptedTerms = useSelector((state) => state.progress.termsAccepted);

  const path = useMemo(() => {
    if (isAuthenticated && acceptedTerms) {
      return "/app";
    }
    if (isAuthenticated && !acceptedTerms) {
      return "/terms";
    }
    return "/signin-oidc";
  }, [isAuthenticated, acceptedTerms]);

  if (orgName) {
    localStorage.org = orgName;
    localStorage.sync = orgAssessmentSync;
  }

  return (
    <div
      className="text-base leading-normal text-gray-600 tracking-wide"
      adoberegion="splash-page"
    >
      <div id="wrapper" className="">
        <div className="container mx-auto lg:px-5 flex justify-center">
          <div className="sm:w-2/3 w-full">
            <div className="bg-white pt-10 pb-8">
              <div className="flex justify-end">
                <LanguageSwitcher redirectTo="/" />
              </div>
              <div className="pt-10">
                <div className="text-center py-20">
                  <Link
                    to={path}
                    onClick={() =>
                      trackAdobeClick(null, {
                        linkTitle: "kickoff logo",
                        linkModule: "splash-page",
                        targetURL: path,
                      })
                    }
                  >
                    <img
                      className="inline-block align-top"
                      src="/images/kickoff.png"
                      alt="imgae description"
                      width="331"
                      height="118"
                    />
                  </Link>
                </div>

                <footer className="footer px-8 py-5 mx-auto text-center sm:px-10 lg:px-8">
                  <strong className="block text-md py-8">
                    {t("startingPoint")}
                  </strong>

                  {!isAuthenticated ? (
                    <div className="flex justify-center">
                      <div className="my-2 bg-white rounded-lg rounded-tr-none">
                        <Link
                          to="/signin-oidc"
                          onClick={() =>
                            trackAdobeClick(null, {
                              linkTitle: t("Login"),
                              linkModule: "splash-page",
                              targetURL: "/signin-oidc",
                            })
                          }
                          className="bg-a-4 flex justify-between block rounded-lg rounded-tr-none text-sm py-2 px-3 cursor-pointer block text-white hover:text-white uppercase"
                        >
                          {t("Login")}
                        </Link>
                      </div>
                      <div className="my-2 ml-3 bg-white rounded-lg rounded-tr-none">
                        <a
                          onClick={() =>
                            trackAdobeClick(null, {
                              linkTitle: t("Create free account"),
                              linkModule: "splash-page",
                              targetURL: `${appSettings.idp}/register`,
                            })
                          }
                          href={`${appSettings.idp}/register?source=default&_cid=ea_scrappypm_client&returnUrl=${appSettings.loginRedirect}`}
                          className="bg-a-4 flex justify-between block rounded-lg rounded-tr-none text-sm py-2 px-3 cursor-pointer block text-white hover:text-white uppercase"
                        >
                          {t("Create free account")}
                        </a>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to={path}
                      onClick={() =>
                        trackAdobeClick(null, {
                          linkTitle: t("tapToStart"),
                          linkModule: "splash-page",
                          targetURL: path,
                        })
                      }
                      className="uppercase font-bold font-secondary tracking-wide text-gray-400 hover:text-gray-600"
                    >
                      {t("tapToStart")}
                    </Link>
                  )}
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;
